import {Loader} from "./Infinite-loader"
(function(){
    const LOADER_CLASS = "infinite-loader"
    document.querySelectorAll(`.${LOADER_CLASS}`).forEach((IL) => IL && new Loader.InfiniteLoader(IL))
})()